import React, { useState, useContext, cloneElement, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LightBox from 'components/LightBox';
import LoginContainer from 'components/pages/LoginContainer';
import { useForm } from "react-hook-form";
import { GlobalContext } from 'store/context/GlobalContext';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { isMobile } from 'react-device-detect';
import { addVote } from 'services/authService';
import useGa from 'hooks/useGa';

export default function VoteButton(props) {
    const gaTracking = useGa();
    const { children, voteType, week } = props;
    const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
    const [ loginLightbox, setLoginLightbox ] = useState(false);
    const [ voteTypeLightbox, setVoteTypeLightbox ] = useState(false);
    const [ voteSuccessLightbox, setVoteSuccessLightbox ] = useState(false);
    const [ pointsLightbox, setPointsLightbox ] = useState(false);
    const [ inputLightbox, setInputLightbox ] = useState(false);
    const [ checkboxLightbox, setCheckboxLightbox ] = useState(false);
    const [ voteEndLightbox, setVoteEndLightbox ] = useState(false);

    const handleClick = () => {
        gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-btn`);
        if(!isAuthenticated){
            setLoginLightbox(true);
            return;
        }
        setVoteTypeLightbox(true);
    }

    return (<>
        {cloneElement( children, { onClick: () => handleClick() })}
        <LoginLightbox toggle={loginLightbox} setToggle={setLoginLightbox} />
        <VoteLightbox
            week={week}
            voteType={voteType}
            toggle={voteTypeLightbox}
            setToggle={setVoteTypeLightbox}
            setVoteSuccessToggle={setVoteSuccessLightbox}
            setPointsToggle={setPointsLightbox}
            setInputToggle={setInputLightbox}
            setCheckboxStatusToggle={setCheckboxLightbox}
            setVoteEndToggle={setVoteEndLightbox}
        />
        <VoteSuccessLightbox
            week={week}
            voteType={voteType}
            toggle={voteSuccessLightbox}
            setToggle={setVoteSuccessLightbox}
            setVoteTypeToggle={setVoteTypeLightbox}
        />
        <PointsLightbox
            week={week}
            voteType={voteType}
            toggle={pointsLightbox}
            setToggle={setPointsLightbox}
        />
        <InputCheckLightbox toggle={inputLightbox} setToggle={setInputLightbox} />
        <CheckboxLightbox
            week={week}
            voteType={voteType}
            toggle={checkboxLightbox}
            setToggle={setCheckboxLightbox}
        />
        <VoteEndLightbox
            week={week}
            voteType={voteType}
            toggle={voteEndLightbox}
            setToggle={setVoteEndLightbox}
        />
    </>)
}

const LoginLightbox = (props) => {
    const { toggle, setToggle } = props;

    return (
        <LightBox
            open={toggle}
            callback={() => setToggle(false)}
            cross
        >
            <div className="light-box-header login-first"></div>
            <div className="light-box-body text-center">
                <div className="text">
                    <div>認明身分再選邊戰，才是好漢。</div>
                    <div>速速登入帳號，用點數來投票吧!</div>
                </div>
                <div className="mgb-8">
                    <LoginContainer setToggle={setToggle} />
                </div>
            </div>
        </LightBox>
    )
}

const VoteLightbox = (props) => {
    const gaTracking = useGa();
    const { week, voteType, toggle, setToggle, setVoteSuccessToggle, setPointsToggle, setInputToggle, setCheckboxStatusToggle, setVoteEndToggle } = props;
    const [ quantity, setQuantity ] = useState(1);
    const { handleSubmit, reset, setValue, setError, formState: { isDirty, isValid, errors }, register } = useForm({ mode: 'onChange', shouldUnregister: true });
    const [ checkboxToggle, setCheckboxToggle ] = useState(false);
    const user = useSelector((state) => state.Auth.user);
    const context = useContext(GlobalContext);
    const { userData, setUserData, setLoader } = context;

    useEffect(() => {
        reset({
            form_name: userData.form_name,
            form_email: userData.form_email,
            form_phone: userData.form_phone,
        })
    }, [userData])

    const onSubmit = (data) => {
        gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-submit`);
        if(data.form_name === "" || data.form_email === "" || data.form_phone === ""){
            setInputToggle(true);
            return;
        }

        if(!checkboxToggle){
            setCheckboxStatusToggle(true);
            return;
        }

        let result = {
            login_id: user.login_id,
            event_id: userData.event_id,
            vote_week: week,
            vote_type: voteType === "calpis" ? "calpis" : "16cha",
            vote_nu: quantity,
            device: isMobile ? "m" : "pc",
            form_address: userData.form_address,
            ...data,
        }

        const formData = new FormData();
        Object.keys(result).map(function(key) {
            if(Array.isArray(result[key])){
                for(let i = 0; i< result[key].length; i++){
                    formData.append(`${key}[${i}]`,result[key][i]);
                }
            }else{
                return formData.append(key, result[key]);
            }
        });

        setLoader(true);
        addVote(formData).then(res => {
            setTimeout(() => {
                if(res.result){
                    setLoader(false);
                    setVoteSuccessToggle(true);
                    setUserData({
                        ...userData,
                        vote_list: res.vote_list,
                        user_last_points: res.user_last_points,
                        user_points: res.user_points,
                        user_used_points: res.user_used_points,
                        form_name: data.form_name,
                        form_email: data.form_email,
                        form_phone: data.form_phone,
                    })
                    setToggle(false);
                    setTimeout(() => {
                        setQuantity(1);
                    }, 300)
                }else{
                    if(res.end){
                        setLoader(false);
                        alert(res.msg);
                        return;
                    }
                    if(res.open_round !== parseInt(week)){
                        setLoader(false);
                        setVoteEndToggle(true);
                        return;
                    }
                    if(!res.point_check){
                        setLoader(false);
                        setPointsToggle(true);
                        return;
                    }
                }
            }, 500)
        })
    }

    return (
        <LightBox
            open={toggle}
            callback={() => {
                setToggle(false);
                setTimeout(() => {
                    setQuantity(1);
                    reset({
                        form_name: userData.form_name,
                        form_email: userData.form_email,
                        form_phone: userData.form_phone,
                    })
                    setCheckboxToggle(false);
                }, 300)
            }}
            cross
        >
            <div className={`light-box-header${voteType === "calpis" ? ' vote-calpis' : ' vote-cha'}`}></div>
            <div className="light-box-body text-center">
                <div className="text mgy-2">
                    <div style={{color: "#EE8287"}}>剩餘 {userData.user_last_points ? userData.user_last_points : "0"} 點</div>
                    <div>請選擇投票點數</div>
                </div>
                <div className="quantity-box">
                    <button
                        type="button"
                        className="quantity-btn minus"
                        data-text="-"
                        disabled={quantity <= 1}
                        onClick={() => {
                            gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-minus-quantity`);
                            setQuantity(quantity - 1);
                        }}
                    ></button>
                    <div className="quantity">{quantity}</div>
                    <button
                        type="button"
                        className="quantity-btn plus"
                        data-text="+"
                        disabled={quantity >= userData.user_last_points}
                        onClick={() => {
                            gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-plus-quantity`);
                            setQuantity(quantity + 1);
                        }}
                    ></button>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="vote-form">
                    <div className="vote-form-group">
                        <label>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</label>
                        <input
                            tabIndex="1"
                            className={errors.form_name ? 'error' : ''}
                            name="form_name"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_name", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空',
                                },
                                pattern: {
                                    value: /^[\u4e00-\u9fa5]+$/i,
                                    message: '* 請填寫中文姓名',
                                },
                            })}
                        />
                    </div>
                    { errors.form_name && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "80px"}}>{errors.form_name.message}</div> }
                    <div className="vote-form-group">
                        <label>電子信箱</label>
                        <input
                            tabIndex="1"
                            className={errors.form_email ? 'error' : ''}
                            name="form_email"
                            type="text"
                            inputMode="email"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_email", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空',
                                },
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: '* 信箱格式不正確',
                                },
                            })}
                        />
                    </div>
                    { errors.form_email && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "80px"}}>{errors.form_email.message}</div> }
                    <div className="vote-form-group">
                        <label>聯絡電話</label>
                        <input
                            tabIndex="1"
                            className={errors.form_phone ? 'error' : ''}
                            name="form_phone"
                            pattern="[0-9]*"
                            type="text"
                            maxLength="10"
                            inputMode="numeric"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_phone", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空 (限定數字)',
                                },
                                pattern: {
                                    value: /\d{2,4}-?\d{3,4}-?\d{3,4}#?(\d+)?/g,
                                    message: '* 聯絡電話格式不正確',
                                },
                                onChange: (e) => setValue("form_phone", e.target.value.replace(/\D/g,'')),
                                onWheel: (e) => e.target.blur(),
                                onPaste: (e) => e.preventDefault(),
                            })}
                        />
                    </div>
                    { errors.form_phone && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "80px"}}>{errors.form_phone.message}</div> }
                    <div className="mgt-4 mgb-3">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="agree"
                                    size="small"
                                    checked={checkboxToggle}
                                    value="checked"
                                    onChange={() => setCheckboxToggle(!checkboxToggle)}
                                />
                            }
                            label={
                                <div className="font-size-14 font-family-notosans">
                                    我已閱讀並同意<Link to="/activity" target="_blank" className="text-decoration-underline fw-bold">活動辦法及隱私權規範</Link>
                                </div>
                            }
                            sx={{margin: "0 0 0 -10px"}}
                        />
                    </div>
                    <div>
                        <button type="submit" className="common-btn yellow">確定投票</button>
                    </div>
                </form>
            </div>
        </LightBox>
    )
}

const VoteSuccessLightbox = (props) => {
    const gaTracking = useGa();
    const { week, voteType, toggle, setToggle, setVoteTypeToggle } = props;

    const handleClose = () => {
        gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-submit-success`);
        setToggle(false);
        setVoteTypeToggle(false);
    }

    return (
        <LightBox
            open={toggle}
            callback={() => setToggle(false)}
        >
            <div className="light-box-header vote-success"></div>
            <div className="light-box-body text-center">
                <div className="text">
                    <div>本回合將於 2022 年 09 月 13 日公布對決結果。押注在五戰中最終勝利方的點數，即自動成為抽獎資格次數，投越多票中獎機率越高。</div>
                    <div>豪華和牛宴得獎名單將於 2022 年 09 月 20 日於本活動網站公布，敬請密切鎖定。</div>
                </div>
                <button type="button" className="common-btn yellow mgb-8" onClick={handleClose}>我知道了</button>
            </div>
        </LightBox>
    )
}

const PointsLightbox = (props) => {
    const gaTracking = useGa();
    const { week, voteType, toggle, setToggle } = props;

    return (
        <LightBox
            open={toggle}
            callback={() => setToggle(false)}
            cross
        >
            <div className="light-box-header points-not-enough"></div>
            <div className="light-box-body text-center">
                <div className="text">
                    <div>購買十六茶與「可爾必思」指定商品，登錄瓶貼序號兌換點數，即刻參加投票！</div>
                </div>
                <Link to="/exchange" className="common-btn yellow mgb-8" onClick={() => gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-points-error`)}>登錄序號</Link>
            </div>
        </LightBox>
    )
}

const InputCheckLightbox = (props) => {
    const { toggle, setToggle } = props;

    return (
        <LightBox
            open={toggle}
            callback={() => setToggle(false)}
            className="custom-light-box"
            cross
        >
            <div className="light-box-body text-center">
                <div className="text">
                    <div>請先填寫完整資料</div>
                </div>
                <button type="button" className="common-btn yellow mgb-8" onClick={() => setToggle(false)}>確認</button>
            </div>
        </LightBox>
    )
}

const CheckboxLightbox = (props) => {
    const gaTracking = useGa();
    const { week, voteType, toggle, setToggle } = props;

    return(
        <LightBox
            open={toggle}
            callback={() => setToggle(false)}
            className="custom-light-box"
            cross
        >
            <div className="light-box-body text-center">
                <div className="text">
                    <div>請閱讀並勾選活動辦法及隱私權規範</div>
                </div>
                <button
                    type="button"
                    className="common-btn yellow mgb-8"
                    onClick={() => {
                        gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-agree-error`);
                        setToggle(false);
                    }}
                >
                    確認
                </button>
            </div>
        </LightBox>
    )
}

const VoteEndLightbox = (props) => {
    const gaTracking = useGa();
    const { voteType, week, toggle, setToggle } = props;

    const handleWeek = () => {
        switch (week){
            case "1": return <><div>本回合投票已於 2022 年 08 月 19 日 24:00 結束。</div><div>歡迎參加下一回合的PK戰！</div></>;
            case "2": return <><div>本回合投票已於 2022 年 08 月 25 日 24:00 結束。</div><div>歡迎參加下一回合的PK戰！</div></>;
            case "3": return <><div>本回合投票已於 2022 年 08 月 31 日 24:00 結束。</div><div>歡迎參加下一回合的PK戰！</div></>;
            case "4": return <><div>本回合投票已於 2022 年 09 月 06 日 24:00 結束。</div><div>歡迎參加下一回合的PK戰！</div></>;
            case "5": return <><div>中秋烤宴集點選邊戰投票活動已於 2022 年 09 月 12 日 24:00 結束。</div><div>豪華和牛得獎名單將於 2022 年 09 月 20 日於本活動網站公布，敬請密切鎖定。</div></>;
            default: return <><div>本回合投票已於 2022 年 08 月 19 日 24:00 結束。</div><div>歡迎參加下一回合的PK戰！</div></>;
        }
    }

    return (
        <LightBox
            open={toggle}
            callback={() => setToggle(false)}
        >
            <div className="light-box-body text-center">
                <div className="text font-size-18">
                    {handleWeek()}
                </div>
                <button
                    type="button"
                    className="common-btn yellow mgb-8"
                    onClick={() => {
                        gaTracking(`vote-round${week}-${voteType === "calpis" ? "calpis" : "16cha"}-end-error`);
                        window.location.reload();
                    }}
                >
                    確認
                </button>
            </div>
        </LightBox>
    )
}